import styled from "@emotion/styled";
export const RadioLabel = styled("label")`
    display: flex;
    align-items: flex-start;
    width: fit-content;

    /* This is relatively positioned so the radio icon can be absolutely positioned. */
    position: relative;
`;
//# sourceMappingURL=RadioLabel.js.map